<template>
    <div v-if="messages" ref="wrapper">
        <template v-for="msg in messages">
            <b-alert v-bind:variant="msg.type" show>{{msg.message}}</b-alert>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            messages: {
                type: Array,
                default: [],
            },
            scroll: {
                type: Boolean,
                default: false,
            },

        },
        watch: {
            messages(){
                if (
                    this.messages
                    && this.messages.length
                    && this.scroll
                    && this.$refs
                    && this.$refs.wrapper
                    && this.$refs.wrapper.scrollIntoView) {
                    this.$nextTick(() => {
                        this.$refs.wrapper.scrollIntoView({block: "start", inline: "nearest", behavior: "smooth"})
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Messages.vue